module.exports = __webpack_public_path__ + "static/media/Piercing-tongue.362065c5.png";